import { Typography, useTheme, Box, Grid } from '@mui/material';

// Components
import { IContributeDetailCompany } from 'src/utils/typings/response/contribute';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { getPeopleRelatedRoleLabel } from 'src/features/ContributionDetail/config';

const RelatedCorporate = ({ dataContribution }: { dataContribution: IContributeDetailCompany }) => {
  const theme = useTheme();

  return (
    <Box
      width="100%"
      padding={2}
      border={`1px dashed ${theme.palette.divider}`}
      borderRadius={theme.shape.borderRadius / 2}
    >
      <Grid container rowGap={2}>
        {getArrayDefault(
          dataContribution?.contribution_related_corporates?.map((item, index) => (
            <Grid key={`contribute-email-company-${index}`} item xs={6}>
              <Typography align="left" variant="caption2" color="text.secondary" component="p">
                Person {index + 1}
              </Typography>
              <Box mt={1} />
              <Box textAlign="left">
                <Typography align="left" component="span" variant="body2" color="text.primary">
                  {renderTextOrDefault(item.people_name)}
                </Typography>
                <Box
                  mx={1}
                  component="span"
                  display="inline-block"
                  sx={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: theme.palette.divider,
                    borderRadius: 1000,
                  }}
                />

                <Typography align="left" component="span" variant="body2" color="text.primary">
                  {getPeopleRelatedRoleLabel(item.people_role)}
                </Typography>
              </Box>
            </Grid>
          )),
        )}
      </Grid>
    </Box>
  );
};

export default RelatedCorporate;
